import {
    DEALERVIEWUSERMASTER_SUCCESS,
    DEALERVIEWUSERMASTER_FAILED,
    RESET_DEALERVIEWUSERMASTER,
    LOADING_DEALERVIEWUSERMASTER,
    NETWORK_ERROR_DEALERVIEWUSERMASTER
} from "../types/index";
import { dealerServices } from "../../config/axios";

const resetDealerViewUserMaster = () => {
    return { type: RESET_DEALERVIEWUSERMASTER };
};

const dealerViewUserMaster = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERVIEWUSERMASTER });
    await dealerServices
        .post("getViewMasterList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerViewUserMastersuccess(res.data));
                    break;
                default:
                    dispatch(dealerViewUserMasterFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERVIEWUSERMASTER,
                payload: err
            });
        });
};
function dealerViewUserMastersuccess(data) {
    return {
        type: DEALERVIEWUSERMASTER_SUCCESS,
        payload: data
    };
}
function dealerViewUserMasterFailed(data) {
    return {
        type: DEALERVIEWUSERMASTER_FAILED,
        payload: data
    };
}

export { resetDealerViewUserMaster, dealerViewUserMaster };
